import PermissionButton from "../../components/ui/PermissionButton";
import { useState } from "react";

export default function AddCategoryModal({ onClose, onSave }) {
  const [category, setCategory] = useState("");

  const saveCategory = async () => {
    if (!category.trim()) return;

    try {
      const res = await fetch("/api/inventory/categories", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name: category.trim() }),
      });

      const data = await res.json();

      if (data.status !== "success") {
        alert(data.message);
        return;
      }

      onSave(category.trim());

    } catch (err) {
      console.error(err);
      alert("Failed to add category");
    }
  };

  return (
    <Modal onClose={onClose}>
      <h2 className="text-xl font-serif mb-4">Add New Category</h2>

      <input
        placeholder="Category name (e.g. Dry Fruits, Dairy)"
        value={category}
        onChange={(e) => setCategory(e.target.value)}
        className="w-full px-4 py-2 rounded-lg bg-black/40 border border-white/10 mb-6"
      />

      <div className="flex justify-end gap-4">
        <PermissionButton permissionModule="inventory"
          onClick={onClose}
          className="px-6 py-2 rounded-xl border border-white/20"
        >
          Cancel
        </PermissionButton>

        <PermissionButton permissionModule="inventory"
          onClick={saveCategory}
          className="px-6 py-2 rounded-xl bg-amber-400 text-black font-medium"
        >
          Add Category
        </PermissionButton>
      </div>
    </Modal>
  );
}

function Modal({ children, onClose }) {
  return (
    <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center">
      <div className="w-full max-w-md rounded-2xl bg-[#0b0b0f] border border-white/10 p-8 relative">
        <PermissionButton permissionModule="inventory"
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-white"
        >
          ✕
        </PermissionButton>
        {children}
      </div>
    </div>
  );
}
